export enum Namespace {
    translations = 'translations',
    translator = 'translator',
}

export type Translations = {
    [key: string]: string | Translations;
};
